import { render, staticRenderFns } from "./SendUpsertDeli.vue?vue&type=template&id=4a1457eb&scoped=true&"
import script from "./SendUpsertDeli.vue?vue&type=script&lang=js&"
export * from "./SendUpsertDeli.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1457eb",
  null
  
)

export default component.exports